import React from "react";
import ReactDOM from "react-dom";

const Backdrop = (props) => {
  return (
    <div
      className="fixed top-0 left-0 w-full h-screen bg-[#017A59] bg-opacity-20 z-40"
      onClick={props.onClose}
    />
  );
};

const Overlay = (props) => {
  return (
    <div className="fixed iphone7:top-[56.5vh] overflow-y-auto lg:overflow-y-hidden iphone7:pb-52 iphone12:pb-5 pb-0 iphone14:top-[38.5vh] iphone12:top-[42.5vh] iphoneXr:top-[40.8vh] pixel7:top-[39vh] iphone7:h-[27rem] top-[45vh] left-1/2 transform md:top-[22.5vh] translate-x-[-50%] xl:w-[95%] w-[90%] lg:h-[20.6875rem] lg:top-[28vh] md:w-[73%] md:h-[29.7rem] lg:w-[95%] h-[27rem] xl:h-[21rem] bg-white p-0 sm:p-[1rem] rounded-xl shadow-2xl z-40">
      <div>{props.children}</div>
    </div>
  );
};
const portalElements = document.getElementById("overlays");
const BModal3 = (props) => {
  return (
    <>
      {ReactDOM.createPortal(
        <Backdrop onClose={props.onClose} />,
        portalElements
      )}
      {ReactDOM.createPortal(
        <Overlay>{props.children}</Overlay>,
        portalElements
      )}
    </>
  );
};

export default BModal3;
